export default __webpack_public_path__ + "static/btweb-windows-screen@2x-a4b40bde9970fb77a5137854528ebdd1.png";